import {Component, OnInit, inject} from '@angular/core';
import { Router } from "@angular/router";
import {Store} from "@ngrx/store";
import {SubmissionHistoryService} from "./shared/services/submission-history.service";
import {AuthService} from "./auth/services/auth-service";
import {resetBrowserHistory} from "./core/utils/check-auth-callback-error";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: [ './app.component.scss' ]
})
export class AppComponent implements OnInit {
    public title: string = 'Dashboard Project';
    public version = {
        'application-version': '@project.version@',
        'application-name': 'Dashboard Project'
    }

    private readonly store = inject(Store);

    constructor ( private router: Router,
                  private submissionHistoryService: SubmissionHistoryService,
                  private authService: AuthService) {
    }

    ngOnInit() {
        this.authService.checkAuth().subscribe(authResult => {
            if (authResult.response.isAuthenticated) {
                sessionStorage.removeItem("triedAuth")
                this.submissionHistoryService.reloadUserData();
                if (sessionStorage.getItem("previousLocation") != null) {
                    const previousLocation = sessionStorage.getItem("previousLocation");
                    sessionStorage.removeItem("previousLocation");
                    window.location.replace(previousLocation);
                }
            } else {
                if (sessionStorage.getItem("triedAuth") !== "true") {
                    sessionStorage.setItem("triedAuth", "true")
                    if (!window.location.href.endsWith('/dashboardui') && !window.location.href.endsWith('/dashboardui/#')) {
                        sessionStorage.setItem("previousLocation", window.location.href);
                    }
                    this.authService.login();
                } else {
                    sessionStorage.clear();
                    if (authResult.callbackError !== null && authResult.callbackError.error !== null) {
                        if (authResult.callbackError.error === 'access_denied' && authResult.callbackError.errorDescription.indexOf("not assigned") > 0) {
                            window.location.replace('/nmdp_401.html');
                        } else {
                            window.location.replace('/nmdp_auth_error.html');
                        }
                    } else {
                        // Might have had an error state before. Retry the login now that the session variables are cleared.
                        window.location.reload();
                    }
                }
            }
        })
    }

    isLoggedIn(): boolean {
        var isAuthed = false;
        this.authService.isAuthenticated().subscribe(({ isAuthenticated }) => {
            isAuthed = isAuthenticated
        });
        return isAuthed;
    }
}
